import classes from "./AccountInfo.module.css";
import { ButtonPrimary } from "../../components/Button/Button";

const AccountInfo = () => {
  return (
    <div className={classes.personalInfo}>
      <ul className={classes.personalInfoList}>
        <li>
          <label>姓名</label>
          <div className={classes.name}>
            <input placeholder="葉" />
            <input placeholder="家銘" />
          </div>
        </li>
        <li className={classes.password}>
          <label>密碼</label>
          <input placeholder="輸入舊密碼" />
          <input placeholder="輸入新密碼" />
          <input placeholder="再輸入一次新密碼" />
        </li>
        <ButtonPrimary text="更改" />
      </ul>
    </div>
  );
};

export default AccountInfo;
